
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ServiceItemProps } from ".";
import { loading, endLoading } from "store/service";

interface ApiServiceRemoveInputProps {
    ids: number[]
}

type ApiServiceRemoveOutputProps = OutputBaseProps<{ item: ServiceItemProps; }>

export const apiServiceRemove = async (data: ApiServiceRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiServiceRemoveOutputProps>("/api/service/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};